import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Button from "../UI/Button";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  title: {
    marginBottom: "10px",
  },
});

const DisciplinaTableSelectView = ({ disciplinas, onDisciplinaSelected }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.title} variant="body1">
        Selecione uma disciplina
      </Typography>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {disciplinas.map((disciplina) => (
            <TableRow key={disciplina.codigo}>
              <TableCell>{disciplina.descricao}</TableCell>
              <TableCell>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={() => onDisciplinaSelected(disciplina)}
                  className={classes.submit}
                >
                  Selecionar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default DisciplinaTableSelectView;
